import { ITurno } from "../models/turno";
import TurnoItem from "./turno-item";
import ReactPlayer from 'react-player';
import CarouselMedia from "./CarouselMedia";
import { useEffect, useState } from 'react';

interface IMdnPageProps {
  turnos: ITurno[];
  date: string;
}

const MdnPage = (props: IMdnPageProps): JSX.Element => {
  // Hooks para configuración del carrusel
  const [mediaList, setMediaList] = useState<{ url: string; type: 'image' | 'video' | 'youtube'; }[]>([
    { url: "https://ioipcorestorageaccount.blob.core.windows.net/ioip-core-static-files/clients/mdn/VID-20230712-WA0000.mp4", type: "video" }
  ]);
  const [interval, setIntervalValue] = useState<number>(5000);
  const [enableAudio, setEnableAudio] = useState<boolean>(true);
  const [useCarousel, setUseCarousel] = useState<boolean>(false);

  // Obtener el cliente actual
  const currentClient = (window as any).domain || 'MDN';
  const configKey = `carousel_config_${currentClient}`;

  // Cargar configuración guardada
  useEffect(() => {
    try {
      const saved = localStorage.getItem(configKey);
      
      if (saved) {
        const parsed = JSON.parse(saved);
        
        // Solo usar carrusel si hay múltiples elementos configurados explícitamente
        if (Array.isArray(parsed.mediaList) && parsed.mediaList.length > 1) {
          setMediaList(parsed.mediaList);
          setUseCarousel(true);
        }
        
        if (typeof parsed.interval === 'number' && parsed.interval > 0) {
          setIntervalValue(parsed.interval);
        }
        if (typeof parsed.enableAudio === 'boolean') {
          setEnableAudio(parsed.enableAudio);
        }
      }
    } catch (error) {
      console.error('MDN: Error al cargar configuración:', error);
    }
  }, [configKey, currentClient]);

  return (
    <div className='tv'>
      <div className='header'>
        <img
          src="https://ioipcorestorageaccount.blob.core.windows.net/ioip-core-static-files/clients/mdn/logo-tv.png"
          alt="Logo MDN"
          style={{
            height: '80px',
            margin: '10px'
          }}
        />
      </div>
      <div className='content'>
        <div className='multimedia-mdn' style={{ userSelect: 'none', boxShadow: '0px 0px 5px 2px #020202' }}>
          {(() => {
            
            if (useCarousel) {
              return <CarouselMedia mediaList={mediaList} interval={interval} enableAudio={enableAudio} useNativeVideo={false} />;
            } else {
              return (
                <ReactPlayer
                  url="https://ioipcorestorageaccount.blob.core.windows.net/ioip-core-static-files/clients/mdn/VID-20230712-WA0000.mp4"
                  playing={true}
                  loop={true}
                  controls={true}
                  width={'100%'}
                  height={'100%'}
                  onReady={() => {
                  }}
                  onError={(e) => {
                    console.error('MDN: Video error:', e);
                  }}
                  onStart={() => {
                  }}
                />
              );
            }
          })()}
        </div>
        <div className='items'>
          {
            props.turnos.map((turno) => <TurnoItem key={turno.id} value={turno} />)
          }
        </div>
      </div>
      <div className='footer'>
        <div className='footer-table'>
          <div data-role="row">
            <div data-role="cell" className='time-cell'>
              {props.date.split('|')[1] || ''}
              <br />
              {props.date.split('|')[0] || ''}
            </div>
            <div data-role="cell" style={{ width: 'calc(100% - 120px)' }}>
              <div className='marquee'>
                <div className="marquee">
                  {<p style={{ paddingTop: '6px' }}>La Oficina de Relación con el Ciudadano cuenta con la sala Denuncia Segura a través de la cual usted podrá interponer denuncias protegiendo la identidad del denunciante y tramitando de forma efectiva su solicitud, nuestro horario de atención en días hábiles son de Lunes a Viernes de 8:00 am a 5:00 pm jornada continua, así mismo puede radicar Derechos de Petición de competencia del Sector Defensa y recibir atención personalizada. También puede realizar sus solicitudes al correo usuarios@mindefensa.gov.co y comunicarse con nosotros a través de la línea gratuita nacional 018000954513.</p>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MdnPage; 